module.exports = __webpack_public_path__ + "img/nopeople12.602c2f45.png";